export enum ApiTokenFormFieldEnum {
    TOKEN_NAME = "tokenName",
    USER_NAME = "userName",
    EXPIRY_IN_YEARS = "expiryInYears",
    ROLE = "role"
}